import { ActionCenterSettings, TastyPieListResponse } from "@/types/djangio"
import { useQuery } from "@tanstack/react-query"

const fetchActionCenterSettings = async (): Promise<TastyPieListResponse<ActionCenterSettings>> => {
    return await DjangIO.app.grassroots.models.ActionCenterSettings.objects
        .filter({
            archived: false,
            dehydrate_extra: ["campaign_count", "domain", "custom_interaction_types"],
        })
        .GET()
}

export const useActionCenterSettings = () =>
    useQuery({
        queryKey: ["actionCenterSettings"],
        queryFn: fetchActionCenterSettings,
        select: (data) => data.objects,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

const fetchSingleActionCenterSettings = async (id: string): Promise<ActionCenterSettings> => {
    return await DjangIO.app.grassroots.models.ActionCenterSettings.objects
        .get(id)
        .filter({
            dehydrate_extra: ["campaign_count", "domain", "custom_interaction_types"],
        })
        .GET()
}

export const useSingleActionCenterSettings = (id: string) =>
    useQuery({
        queryKey: ["actionCenterSettings", id],
        queryFn: () => fetchSingleActionCenterSettings(id),
        enabled: Boolean(id),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })
